import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncAppleMusicToTidal() {
    return (
        <GuidesPage
            seoData={seoContent.syncAppleMusicToTidal}
            sections={<PairSyncGuideContent sourceKey="appleMusic" destKey="tidal" />}
        />
    );
}
